import { useState } from "react";
import { Link } from "react-router-dom";
import { FileSpreadsheet, CheckSquare, Cable, Percent } from "lucide-react";
import { toast } from "sonner";
import { PRODUCTS, fmt } from "../../data/store";

const CONTRACT = PRODUCTS.slice(0, 6).map((p) => ({ ...p, contractPrice: Math.round(p.price * 0.82 * 100) / 100 }));

const APPROVALS = [
  { id: "APR-11", by: "Jānis (noliktava)", what: "Pasūtījums 24 × Grīdas mazgāšanas līdzeklis 5 L", total: 309.6 },
  { id: "APR-12", by: "Laura (birojs)", what: "Pasūtījums 48 × Papīra dvieļi 2 slāņi", total: 95.52 },
];

export default function AccB2B() {
  const [approvals, setApprovals] = useState(APPROVALS);
  const decide = (id, ok) => {
    setApprovals((p) => p.filter((a) => a.id !== id));
    toast.success(ok ? "Pasūtījums apstiprināts (DEMO)" : "Pasūtījums noraidīts (DEMO)");
  };
  const upload = (e) => {
    e.preventDefault();
    toast.success("SKU saraksts augšupielādēts (DEMO)", { description: "Piedāvājums ar jūsu līguma cenām būs gatavs 1 darba dienā." });
    e.target.reset();
  };

  return (
    <div className="space-y-8" data-testid="account-b2b">
      <div>
        <h2 className="text-xl font-extrabold uppercase mb-1 flex items-center gap-2"><CheckSquare size={19} className="text-[#D0121A]" /> Apstiprinājumi gaida Jūsu lēmumu ({approvals.length})</h2>
        <p className="text-sm text-[#6B6B6B] mb-3">Jūsu komandas izveidotie pasūtījumi, kas pārsniedz limitu 50 €.</p>
        {approvals.length === 0 && <p className="text-sm text-[#6B6B6B] border border-[#E2E2E2] p-4" data-testid="approvals-empty">Nav gaidošu apstiprinājumu.</p>}
        <div className="space-y-2">
          {approvals.map((a) => (
            <div key={a.id} className="border border-[#E2E2E2] p-4 flex flex-wrap items-center gap-3" data-testid={`approval-${a.id}`}>
              <div className="flex-1 min-w-[200px]">
                <div className="text-sm font-bold">{a.what}</div>
                <div className="text-xs text-[#6B6B6B]">Izveidoja: {a.by} · {fmt(a.total)} ar PVN</div>
              </div>
              <button onClick={() => decide(a.id, true)} data-testid={`approval-yes-${a.id}`} className="bg-[#1E9E45] hover:bg-[#188038] text-white text-xs font-bold px-4 py-2 transition-colors">Apstiprināt</button>
              <button onClick={() => decide(a.id, false)} data-testid={`approval-no-${a.id}`} className="border border-[#E2E2E2] hover:border-[#D0121A] hover:text-[#D0121A] text-xs font-bold px-4 py-2 transition-colors">Noraidīt</button>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h2 className="text-xl font-extrabold uppercase mb-1 flex items-center gap-2"><Percent size={19} className="text-[#D0121A]" /> Jūsu līguma cenas</h2>
        <p className="text-sm text-[#6B6B6B] mb-3">B2B Zelta līmenis: –18% no bāzes cenas. Cenas bez PVN.</p>
        <div className="border border-[#E2E2E2] overflow-x-auto">
          <table className="w-full text-sm min-w-[560px]">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-[#6B6B6B] border-b border-[#E2E2E2]">
              <th className="p-3">Prece</th><th>Bāzes cena</th><th>Jūsu cena</th><th></th>
            </tr></thead>
            <tbody>
              {CONTRACT.map((p) => (
                <tr key={p.id} className="border-b border-[#F5F5F5]" data-testid={`contract-row-${p.id}`}>
                  <td className="p-3 font-semibold max-w-[260px] truncate">{p.name}</td>
                  <td className="line-through text-[#6B6B6B]">{fmt(p.price)}</td>
                  <td className="font-extrabold text-[#D0121A]">{fmt(p.contractPrice)}</td>
                  <td className="p-3"><Link to={`/prece/${p.id}`} className="text-xs font-bold hover:text-[#D0121A] underline">Skatīt</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <form onSubmit={upload} className="bg-[#F5F5F5] p-5" data-testid="sku-upload">
          <h3 className="text-sm font-bold uppercase tracking-widest flex items-center gap-2 mb-2"><FileSpreadsheet size={15} className="text-[#D0121A]" /> Augšupielādēt SKU sarakstu</h3>
          <p className="text-xs text-[#6B6B6B] mb-3">CSV vai Excel ar SKU un daudzumiem — saņemsi piedāvājumu ar līguma cenām.</p>
          <input type="file" accept=".csv,.xlsx" data-testid="sku-file-input" className="block w-full text-xs mb-3 file:bg-[#111111] file:text-white file:border-0 file:px-4 file:py-2 file:text-xs file:font-bold file:mr-3 file:cursor-pointer" />
          <button type="submit" data-testid="sku-upload-btn" className="bg-[#D0121A] hover:bg-[#A80D14] text-white text-xs font-bold px-5 py-2.5 transition-colors">Nosūtīt sarakstu</button>
        </form>
        <div className="bg-[#F5F5F5] p-5" data-testid="erp-block">
          <h3 className="text-sm font-bold uppercase tracking-widest flex items-center gap-2 mb-2"><Cable size={15} className="text-[#D0121A]" /> ERP integrācija</h3>
          <p className="text-xs text-[#6B6B6B] mb-3">API atslēga automātiskai pasūtījumu un e-rēķinu apmaiņai ar jūsu grāmatvedības sistēmu.</p>
          <code className="block bg-white border border-[#E2E2E2] px-3 py-2 text-xs font-mono mb-3">demo_api_key_************3f8a</code>
          <button onClick={() => toast.success("Jauna API atslēga ģenerēta (DEMO)")} data-testid="erp-regenerate" className="bg-[#111111] hover:bg-[#3A3A3A] text-white text-xs font-bold px-5 py-2.5 transition-colors">Ģenerēt jaunu atslēgu</button>
        </div>
      </div>
    </div>
  );
}
